import { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2, Gamepad2, HelpCircle, Grid3x3, DoorClosed } from "lucide-react";
import { toast } from "sonner";
import OSLayout from "../../components/os/OSLayout";
import { api, formatApiError } from "../../lib/api";
import GamePlay from "../../components/os/games/GamePlay";

const META = { trivia: { label: "Trivia", icon: HelpCircle }, memorama: { label: "Memorama", icon: Grid3x3 }, escape: { label: "Escape Room", icon: DoorClosed } };

export default function GamePlayer() {
  const { id } = useParams();
  const [game, setGame] = useState(null);
  const [err, setErr] = useState(null);

  const load = useCallback(() => {
    api.get(`/authoring/games/${id}`).then((r) => { setGame(r.data); setErr(null); })
      .catch((e) => setErr(formatApiError(e.response?.data?.detail) || "No se pudo cargar el juego"));
  }, [id]);
  useEffect(() => { load(); }, [load]);

  const submit = async (payload) => {
    const { data } = await api.post(`/authoring/games/${id}/play`, payload);
    return data;
  };
  const check = async (stage, answer) => {
    try { const { data } = await api.post(`/authoring/games/${id}/check`, { stage, answer }); return !!data.correct; }
    catch { toast.error("No se pudo verificar"); return false; }
  };

  if (err) return <OSLayout title="OMNIA Academy"><div className="py-24 text-center text-navy/50" data-testid="game-error">{err}<div className="mt-3"><Link to="/os/academia" className="text-violet text-sm hover:underline">← Volver a Academy</Link></div></div></OSLayout>;
  if (!game) return <OSLayout title="OMNIA Academy"><div className="py-24 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-violet" /></div></OSLayout>;

  const M = META[game.type] || META.trivia; const Icon = M.icon;
  return (
    <OSLayout title={game.title}>
      <div className="max-w-2xl mx-auto space-y-5" data-testid="game-player">
        <Link to="/os/academia" className="inline-flex items-center gap-2 text-sm text-navy/50 hover:text-navy"><ArrowLeft className="w-4 h-4" /> Volver a Academy</Link>
        <div>
          <div className="flex items-center gap-2 text-violet"><Icon className="w-5 h-5" /><span className="overline text-navy/40">{M.label}</span></div>
          <h1 className="text-3xl font-medium tracking-tight mt-1">{game.title}</h1>
          {game.description && <p className="text-navy/50 mt-1 text-sm">{game.description}</p>}
          {game.best_score != null && <p className="text-xs text-gold mt-1">Tu mejor puntaje: {game.best_score}% · {game.best_stars}★</p>}
        </div>
        <div className="bg-white border border-navy/10 rounded-2xl p-6">
          {game.ready
            ? <GamePlay type={game.type} config={game.config} onSubmit={submit} onCheck={check} />
            : <p className="text-navy/40 text-sm py-8 text-center">Este juego aún no está completo.</p>}
        </div>
      </div>
    </OSLayout>
  );
}
